import React, { useCallback } from 'react'
import './AddProfileCard.scss'
import { PlusIcon } from '@assets/index'
import classNames from 'classnames'
import { VelvetSDK } from 'sdk'
import { TextTag } from '@enums/textTag'
import Text from '@components/Text/Text'
import { onEnterKeyPressAndClick } from '@utils/helpers'
import { profileRoutes } from '@constants/routes.const'
import { useNavigate } from 'react-router-dom'

export const AddProfileCard = () => {
  const V = VelvetSDK.Vocabulary.vocabulary
  const navigate = useNavigate()

  const handleAddProfileNavigation = useCallback(
    (e: React.KeyboardEvent | React.MouseEvent) => {
      e.preventDefault()
      onEnterKeyPressAndClick(e, () => navigate(profileRoutes.CREATE_NEW_PROFILE))
    },
    [navigate],
  )

  return (
    <div className={classNames('add-profile', 'focusable')} tabIndex={-1} onKeyDown={handleAddProfileNavigation} onClick={handleAddProfileNavigation}>
      <div className="add-profile-container">
        <PlusIcon />
      </div>
      <Text tag={TextTag.P}>{V.profileManagementAddProfile}</Text>
    </div>
  )
}
